export default __webpack_public_path__ + "static/media/nextArrow.52ce0b3e.svg";